import { AnalysisInfo } from "./api";

const humanReadableSize = (size: number) => {
  if (size >= 1024 * 1024) {
    const s = size / (1024 * 1024);
    return `${s.toFixed(2)} MB`;
  } else if (size >= 1024) {
    const s = size / 1024;
    return `${s.toFixed(2)} KB`;
  } else {
    return `${size} B`;
  }
};

export const computeAnalysisAttributes = (analysis: AnalysisInfo) => {
  let { rating, rating_flag } = analysis;

  if (rating === undefined || rating === null) {
    rating = -1;
  }

  let color = "unknown";
  let status = rating_flag;

  switch (rating_flag) {
    case "CLEAN FILE": {
      color = "no-risk";
      status = "Known Clean";
      break;
    }
    case "CRITICAL RISK": {
      color = "malicious";
      status = "Malicious";
      break;
    }
    case "ENCRYPTED FILE": {
      status = "Encrypted File";
      break;
    }
    case "HIGH RISK": {
      color = "high-risk";
      status = "High Risk";
      break;
    }
    case "LOW RISK": {
      color = "no-risk";
      status = "Low Risk";
      break;
    }
    case "MEDIUM RISK": {
      color = "suspicious";
      status = "Suspicious";
      break;
    }
    case "UNSUPPORTED FILE": {
      color = "unknown";
      status = "Unsupported";
      break;
    }
    default:
      color = "unknown";
      status = rating_flag;
      break;
  }

  return {
    name: analysis.filename,
    rating,
    analysisId: analysis.analysis_id,
    fileType: analysis.object_type || "Unknown",
    color,
    status,
    size: humanReadableSize(analysis.file_size),
    timestamp: new Date(analysis.timestamp).toISOString(),
    scantime: `${analysis.scan_time_ms} ms`,
    isFavorite: analysis.is_favorite ?? false,
    isPublic: analysis.is_public ?? true,
  };
};
